import { axios } from '@Root/API'

export const remove = moduleId => {
	return axios.delete(`delete/module/${moduleId}`)
}
